import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";

// Layouts
import SubLayout from "./layouts/SubLayout";

// Pages
import Home from "./pages/01_home";
import Policy from "./pages/00_footer/policy"
import Privacy from "./pages/00_footer/privacy"
import Login from "./pages/00_intro/login"
import Signup from "./pages/00_intro/signup"
import IdSearch from "./pages/00_intro/id_search";
import PwSearch from "./pages/00_intro/pw_search";
import PwSearchByEmail from "./pages/00_intro/pw_search_by_email";

// 2. 총학생회 소개
import PresidentGreeting from "./pages/02_introduction/president_greeting";
import ExecutiveCommittee from "./pages/02_introduction/executive_committee";
import SubCommittees from "./pages/02_introduction/sub_committees";
import Location from "./pages/02_introduction/location";

// 3. 중앙대 소식
import StudentCouncilNews from "./pages/03_news/student_council";
import NewsDetail from "./pages/03_news/detail"; // 추가
import CultureCommitteeNews from "./pages/03_news/culture_committee";
import WelfareCommitteeNews from "./pages/03_news/welfare_committee";
import HumanRightsCommitteeNews from "./pages/03_news/human_rights_committee";
import GraduationCommitteeNews from "./pages/03_news/graduation_committee";
import ClubUnionNews from "./pages/03_news/club_union";
import EditBoardPostNews from './pages/03_news/edit_board';
import StudentCouncilAccounting from "./pages/03_news/accounting";
import WriteBoardPostNews from "./pages/03_news/write_board";
import PromoCouncilNews from "./pages/03_news/promo_council";
import StrategyCouncilNews from "./pages/03_news/strategy_council";
import LifeCouncilNews from "./pages/03_news/life_council";
import UnityCouncilNews from "./pages/03_news/unity_council";
import EduCouncilNews from "./pages/03_news/edu_council";
import CalendarNews from "./pages/03_news/calendar"


// 4. 중대 청원
import CreatePetition from "./pages/04_petition/create";
import RegisteredPetitions from "./pages/04_petition/registered";
import AwaitingAnswerPetitions from "./pages/04_petition/awaiting_answer";
import CompletedPetitions from "./pages/04_petition/completed";
import PetitionDetail from "./pages/04_petition/detail";

// 5. 학생 자치
import AutonomyActivity from "./pages/05_student_autonomy/activity";
import StudentCouncilRules from "./pages/05_student_autonomy/council_rules";
import CentralCommitteeMeetings from "./pages/05_student_autonomy/central_committee";
import DepartmentRules from "./pages/05_student_autonomy/department_rules";
import AutonomyDetail from "./pages/05_student_autonomy/detail";
import AnotomyEditBoardPost from './pages/05_student_autonomy/edit_board';
import WriteBoardPostAutonomy from './pages/05_student_autonomy/write_board';

// 6. 교육 및 학사
import AcademicInfo from "./pages/06_education/academic_info";
import MajorAndGraduation from "./pages/06_education/major_graduation";
import FreeBoard from "./pages/06_education/free_board";
import EducationDetail from "./pages/06_education/detail";


// 7. 편의정보
import SpaceAdjustment from "./pages/07_convenience_info/space_adjustment";
import Affiliate from "./pages/07_convenience_info/affiliate";
import ConvenienceDetail from "./pages/07_convenience_info/detail";
import ConvenienceEditBoardPost from './pages/07_convenience_info/edit_board';
import ResidentBusiness from './pages/07_convenience_info/resident_buisiness';
import WriteBoardPostConvenience from './pages/07_convenience_info/write_board';

// 8. 내정보
import ModifyPersonalInfo from "./pages/08_mypage/modify_personal_info";

// 9. 관리자 페이지
import AuthorizationUser from './pages/09_admin/authorization_user';
import ModifySchedule from './pages/09_admin/modify_schedule';
const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                {/* Default Route */}
                <Route path="/" element={<Navigate replace to="/home" />} />
                
                {/* Home */}
                <Route path="/home" element={<Home />}/>
                
                {/* SubLayout을 적용한 페이지들 - navbar, banner, submenus, contents, footer 구조 */}
                <Route element={<SubLayout />}>
                    {/* 2. 총학생회 소개 */}
                    <Route path="/introduction">
                        <Route index element={<Navigate replace to="/introduction/greeting" />} />
                        <Route path="greeting" element={<PresidentGreeting />} />
                        <Route path="executive" element={<ExecutiveCommittee />} />
                        <Route path="committees" element={<SubCommittees />} />
                        <Route path="location" element={<Location />} />
                    </Route>
                    
                    {/* 3. 중앙대 소식 */}
                    <Route path="/news">
                        <Route index element={<Navigate replace to="/news/student-council" />} />
                        <Route path="student-council" element={<StudentCouncilNews />} />
                        <Route path="culture-committee" element={<CultureCommitteeNews />} />
                        <Route path="welfare-committee" element={<WelfareCommitteeNews />} />
                        <Route path="human-rights-committee" element={<HumanRightsCommitteeNews />} />
                        <Route path="graduation-committee" element={<GraduationCommitteeNews />} />
                        <Route path="edu-council" element={<EduCouncilNews />} />
                        <Route path="strategy-council" element={<StrategyCouncilNews />} />
                        <Route path="life-council" element={<LifeCouncilNews />} />
                        <Route path="promo-council" element={<PromoCouncilNews />} />
                        <Route path="unity-council" element={<UnityCouncilNews />} />
                        <Route path="club-union" element={<ClubUnionNews />} />
                        <Route path="accounting" element={<StudentCouncilAccounting />} />
                        <Route path="calendar" element={<CalendarNews />} />
                        <Route path=":category/detail/:id" element={<NewsDetail />} />
                        <Route path=":category/edit/:id" element={<EditBoardPostNews />} />
                        <Route path=":category/write" element={<WriteBoardPostNews />} />

                    </Route>
                    
                    {/* 4. 중대 청원 */}
                    {/* <Route path="/petition">
                        <Route index element={<Navigate replace to="/petition/registered" />} />
                        <Route path="create" element={<CreatePetition />} />
                        <Route path="registered" element={<RegisteredPetitions />} />
                        <Route path="awaiting" element={<AwaitingAnswerPetitions />} />
                        <Route path="completed" element={<CompletedPetitions />} />
                        <Route path=":id" element={<PetitionDetail />} />
                    </Route> */}
                    
                    {/* 5. 학생 자치 */}
                    <Route path="/student-autonomy">
                        <Route index element={<Navigate replace to="/student-autonomy/activity" />} />
                        <Route path="activity" element={<AutonomyActivity />} />
                        <Route path="council-rules" element={<StudentCouncilRules />} />
                        <Route path="central-committee" element={<CentralCommitteeMeetings />} />
                        <Route path="department-rules" element={<DepartmentRules />} />
                        <Route path="space-adjustment" element={<SpaceAdjustment />} />
                        <Route path=":category/detail/:id" element={<AutonomyDetail />} /> 
                        <Route path=":category/edit/:id" element={<AnotomyEditBoardPost />} />
                        <Route path=":category/write" element={<WriteBoardPostAutonomy />} />

                    </Route>
                    {/* 7. 편의 정보 */}
                    <Route path="/convenience-info">
                        <Route index element={<Navigate replace to="/convenience-info/affiliate" />} />
                        <Route path="affiliate" element={<Affiliate />} />
                        <Route path="resident-business" element={<ResidentBusiness />} />
                        <Route path="space-adjustment" element={<SpaceAdjustment />} />
                        <Route path=":category/detail/:id" element={<ConvenienceDetail />} />
                        <Route path=":category/edit/:id" element={<ConvenienceEditBoardPost />} />
                        <Route path=":category/write" element={<WriteBoardPostConvenience />} />

                    </Route>

                    <Route path="mypage">
                        <Route index element={<Navigate replace to="/mypage/edit" />} />
                        <Route path="edit" element={<ModifyPersonalInfo />} />
                    </Route>

                     {/*9. 관리자 페이지*/}
                    <Route path="/admin">
                        <Route index element={<Navigate replace to="/admin/authorization-user" />} />
                        <Route path="authorization-user" element={<AuthorizationUser />} />
                        <Route path="modify-schedule" element={<ModifySchedule />} />
                    </Route>
                    {/* 6. 교육 및 학사 */}
                    {/* <Route path="/education">
                        <Route index element={<Navigate replace to="/education/academic-info" />} />
                        <Route path="academic-info" element={<AcademicInfo />} />
                        <Route path="major-graduation" element={<MajorAndGraduation />} />
                        <Route path="free-board" element={<FreeBoard />} />
                        <Route path=":category/:id" element={<EducationDetail />} />
                    </Route> */}

                    <Route path="/rules">
                        <Route path="policy" element={<Policy />} />
                        <Route path="privacy" element={<Privacy />} />
                    </Route>

                    <Route path="/intro">
                        <Route path="login" element={<Login />} />
                        <Route path="login/id-search" element={<IdSearch />} />
                        <Route path="login/pw-search" element={<PwSearch />} />
                        <Route path="login/pw-search-by-email" element={<PwSearchByEmail />} />
                        <Route path="signup" element={<Signup />} />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default Router;
